import { render, staticRenderFns } from "./ServiceAreasDeliveryWindow.vue?vue&type=template&id=4d7160b0&scoped=true&"
import script from "./ServiceAreasDeliveryWindow.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasDeliveryWindow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasDeliveryWindow.vue?vue&type=style&index=0&id=4d7160b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7160b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7160b0')) {
      api.createRecord('4d7160b0', component.options)
    } else {
      api.reload('4d7160b0', component.options)
    }
    module.hot.accept("./ServiceAreasDeliveryWindow.vue?vue&type=template&id=4d7160b0&scoped=true&", function () {
      api.rerender('4d7160b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/DeliveryWindows/ServiceAreasDeliveryWindow.vue"
export default component.exports